

// frontend/src/components/flight/SearchForm.jsx - Updated to use backend airports
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../../context/BookingContext';
import { flightsAPI } from '../../services/api';

const SearchForm = () => {
  const navigate = useNavigate();
  const { updateSearchParams } = useBooking();
  const [airports, setAirports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    origin: '',
    destination: '',
    departureDate: '',
    returnDate: '',
    passengers: 1,
    classType: 'economy',
    tripType: 'one-way'
  });

  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const airportData = await flightsAPI.getAirports();
        setAirports(airportData);
      } catch (error) {
        console.error('Failed to fetch airports:', error);
        // Fallback to static data if backend fails
        setAirports([
          { code: 'JFK', name: 'John F. Kennedy International', city: 'New York', country: 'USA' },
          { code: 'LAX', name: 'Los Angeles International', city: 'Los Angeles', country: 'USA' },
          { code: 'LHR', name: 'Heathrow', city: 'London', country: 'UK' },
          { code: 'CDG', name: 'Charles de Gaulle', city: 'Paris', country: 'France' }
        ]);
      }
    };

    fetchAirports();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.origin) newErrors.origin = 'Origin is required';
    if (!formData.destination) newErrors.destination = 'Destination is required';
    if (!formData.departureDate) newErrors.departureDate = 'Departure date is required';
    if (formData.tripType === 'round-trip' && !formData.returnDate) {
      newErrors.returnDate = 'Return date is required for round trip';
    }
    if (formData.passengers < 1 || formData.passengers > 9) {
      newErrors.passengers = 'Passengers must be between 1 and 9';
    }
    
    if (formData.origin === formData.destination) {
      newErrors.destination = 'Destination must be different from origin';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setLoading(true);
    updateSearchParams(formData);
    
    try {
      const params = new URLSearchParams({
        origin: formData.origin,
        destination: formData.destination,
        departureDate: formData.departureDate,
        passengers: formData.passengers.toString(),
        classType: formData.classType,
        tripType: formData.tripType,
        ...(formData.returnDate && { returnDate: formData.returnDate })
      });
      
      navigate(`/search?${params.toString()}`);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ 
      backgroundColor: 'white', 
      borderRadius: '8px', 
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', 
      padding: '24px' 
    }}>
      {/* Trip Type */}
      {/* <div style={{ marginBottom: '16px' }}>
        <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
          <label style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="radio"
              name="tripType"
              value="one-way"
              checked={formData.tripType === 'one-way'}
              onChange={handleInputChange}
              style={{ marginRight: '8px' }}
            />
            One Way
          </label>
          <label style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="radio"
              name="tripType"
              value="round-trip"
              checked={formData.tripType === 'round-trip'}
              onChange={handleInputChange}
              style={{ marginRight: '8px' }}
            />
            Round Trip
          </label>
        </div>
      </div> */}

      <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
          <label style={{ display: 'flex', alignItems: 'center', color: '#374151', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
            <input
              type="radio"
              name="tripType"
              value="one-way"
              checked={formData.tripType === 'one-way'}
              onChange={handleInputChange}
              style={{ marginRight: '8px' }}
            />
            One Way
          </label>
          <label style={{ display: 'flex', alignItems: 'center', color: '#374151', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
            <input
              type="radio"
              name="tripType"
              value="round-trip"
              checked={formData.tripType === 'round-trip'}
              onChange={handleInputChange}
              style={{ marginRight: '8px' }}
            />
            Round Trip
          </label>
        </div>

      {/* Flight Search Fields */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
        gap: '16px', 
        marginBottom: '16px' 
      }}>
        {/* From */}
        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
            From
          </label>
          <select
            name="origin"
            value={formData.origin}
            onChange={handleInputChange}
            style={{
              width: '100%',
              padding: '12px',
              border: errors.origin ? '1px solid #ef4444' : '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px',
              outline: 'none'
            }}
          >
            <option value="">Select Origin</option>
            {airports.map(airport => (
              <option key={airport.code} value={airport.code}>
                {airport.code} - {airport.city}
              </option>
            ))}
          </select>
          {errors.origin && <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>{errors.origin}</p>}
        </div>

        {/* To */}
        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
            To
          </label>
          <select
            name="destination"
            value={formData.destination}
            onChange={handleInputChange}
            style={{
              width: '100%',
              padding: '12px',
              border: errors.destination ? '1px solid #ef4444' : '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px',
              outline: 'none'
            }}
          >
            <option value="">Select Destination</option>
            {airports.map(airport => (
              <option key={airport.code} value={airport.code}>
                {airport.code} - {airport.city}
              </option>
            ))}
          </select>
          {errors.destination && <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>{errors.destination}</p>}
        </div>

        {/* Departure Date */}
        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
            Departure
          </label>
          <input
            type="date"
            name="departureDate"
            value={formData.departureDate}
            onChange={handleInputChange}
            min={new Date().toISOString().split('T')[0]}
            style={{
              width: '100%',
              padding: '12px',
              border: errors.departureDate ? '1px solid #ef4444' : '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px',
              outline: 'none'
            }}
          />
          {errors.departureDate && <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>{errors.departureDate}</p>}
        </div>

        {/* Return Date (if round trip) */}
        {formData.tripType === 'round-trip' && (
          <div>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
              Return
            </label>
            <input
              type="date"
              name="returnDate"
              value={formData.returnDate}
              onChange={handleInputChange}
              min={formData.departureDate || new Date().toISOString().split('T')[0]}
              style={{
                width: '100%',
                padding: '12px',
                border: errors.returnDate ? '1px solid #ef4444' : '1px solid #d1d5db',
                borderRadius: '6px',
                fontSize: '14px',
                outline: 'none'
              }}
            />
            {errors.returnDate && <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px' }}>{errors.returnDate}</p>}
          </div>
        )}
      </div>

      {/* Passengers and Class */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', 
        gap: '16px', 
        marginBottom: '24px' 
      }}>
        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
            Passengers
          </label>
          <select
            name="passengers"
            value={formData.passengers}
            onChange={handleInputChange}
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px',
              outline: 'none'
            }}
          >
            {[...Array(9)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1} Passenger{i + 1 > 1 ? 's' : ''}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
            Class
          </label>
          <select
            name="classType"
            value={formData.classType}
            onChange={handleInputChange}
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px',
              outline: 'none'
            }}
          >
            <option value="economy">Economy</option>
            <option value="business">Business</option>
            <option value="first">First Class</option>
          </select>
        </div>
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={loading}
        style={{
          width: '100%',
          backgroundColor: loading ? '#93c5fd' : '#2563eb',
          color: 'white',
          fontWeight: '600',
          padding: '12px 24px',
          borderRadius: '6px',
          border: 'none',
          cursor: loading ? 'not-allowed' : 'pointer',
          fontSize: '16px',
          transition: 'background-color 0.2s'
        }}
      >
        {loading ? 'Searching...' : 'Search Flights'}
      </button>
    </form>
  );
};

export default SearchForm;